import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
// import Multiselect from "multiselect-react-dropdown"; // Not used in provided snippet for this form
// import Dropzone from "react-dropzone"; // Not used
// import { Link } from "react-router-dom"; // Not used
import { Input, Row, Col, Card, CardBody, Button, Spinner } from "reactstrap";
import "../../../App.css";

// Import your table and column creator
// import { BasicTable } from "../Table/CommonTable"; // Adjust path as needed - using CommonDataTable
// import { columns } from "./AiQuestionDataTableColumns"; // Not directly used in AddAIQuestionForm logic, but by CommonDataTable
import { fetchAiQuestions } from "../../../slices/thunks";
import { toast } from "react-toastify";
import CommonDataTable from "../Table/CommonDataTable";

// Assuming tableColumnNames and questiuons are defined as in your provided code
const tableColumnNames =  [
    {
        "ColumnId": 1,
        "FieldName": "Normal",
        "ModuleName": "ASSIGNMENTQUESTIONS",
        "TitleEn": "question_title_english",
        "ValueAr": "سؤال",
        "ValueEn": "Questions",
        "RoleId": [
            1,
            2
        ],
        "UserId": [
            1,
            7
        ],
        "TitleAr": "question_title_arabic",
        "Title": "question_title_english"
    },
    {
        "ColumnId": 2,
        "FieldName": "Normal",
        "ModuleName": "ASSIGNMENTQUESTIONSAI",
        "TitleEn": "QuestionIDs",
        "ValueAr": "اختيار",
        "ValueEn": "Difficulty",
        "RoleId": [
            1,
            2
        ],
        "UserId": [
            1,
            7
        ],
        "TitleAr": "QuestionIDs",
        "Title": "difficulty"
    },
    {
        "ColumnId": 3,
        "FieldName": "Normal",
        "ModuleName": "ASSIGNMENTQUESTIONSAI",
        "TitleEn": "QuestionIDs",
        "ValueAr": "اختيار",
        "ValueEn": "type",
        "RoleId": [
            1,
            2
        ],
        "UserId": [
            1,
            7
        ],
        "TitleAr": "QuestionIDs",
        "Title": "type"
    },
]

const questiuons = [ // Note: 'questiuons' has a typo, should be 'questions' if it's a variable name
        {
            "question_title_english": "React Reconciliation Specificity",
            "question_title_arabic": "تفاصيل خوارزمية التوفيق في React",
            "difficulty": "Very Hard",
            "type": "Objective",
            // ... other properties
        },
        {
            "question_title_english": "React Fiber and Concurrency Implications",
            "question_title_arabic": "بنية React Fiber وتأثيرات التزامن (Concurrency)",
            "difficulty": "Very Hard",
            "type": "Objective",
            // ... other properties
        }
]


const AddAIQuestionForm = ({
    labels,
    formikProps,
    isAddOrEdit,
    setParentSubmitDisabled,
    skipValidation = false, // Added prop to control internal validation logic
}) => {
    const { t, i18n } = useTranslation();
    const dispatch = useDispatch();

    // const { values, errors, touched, handleChange, handleBlur, setFieldValue, setFieldTouched } = formikProps;
    // Destructure touched and errors for consistent usage
    const { values, handleChange, setFieldValue, touched, errors } = formikProps;

    // Selectors for data needed by dropdowns, etc.
    const { ReferralReward, Days, topicsList, subTopics, QuestionTypes, DifficultyLevel, AiQuestions, loadingAi } = useSelector((state) => ({ 
        ReferralReward: state.ReferralReward.referralReward,
        Days: state.Common.days,
        topicsList: state.Topics.topicsList,    
        subTopics: state.SubTopics.subTopics,   
        QuestionTypes: state.Common.questionTypes,
        DifficultyLevel: state.Common.difficultyLevel,
        AiQuestions: state.Questions.aiQuestions,
        loadingAi: state.Questions.loadingAi,
    }));

    // State to hold questions processed with an ID for the data table
    const [questionsForTable, setQuestionsForTable] = useState([]);

    useEffect(() => {
        if (AiQuestions) {
            const processedQuestions = AiQuestions.map((q, index) => ({
                ...q,
                // Ensure an ID exists, prefer existing ID if any, otherwise use index as a fallback
                ID: q.ID !== undefined ? q.ID : (q.Id !== undefined ? q.Id : index)
            }));
            setQuestionsForTable(processedQuestions);
        } else {
            setQuestionsForTable([]);
        }
    }, [AiQuestions]);

    useEffect(() => {
        if (typeof setParentSubmitDisabled === 'function') {
            // Original logic: disable if no questions are selected
            setParentSubmitDisabled(values.QuestionIDs.length === 0);
        }
    // Update dependencies to include skipValidation
    }, [values.QuestionIDs, setParentSubmitDisabled]);


    const renderField = (item) => {
        const fieldName = item.name;
        const fieldValue = values[fieldName] ?? (item.fieldName === 'check-box' ? false : ''); 
        const isDisabled = typeof item.disabled === 'function' ? item.disabled(isAddOrEdit, values) : !!item.disabled;

        switch (item.fieldName) {
            case 'text-box':
                return (
                    <Input
                        type="text"
                        id={fieldName}
                        name={fieldName}
                        placeholder={t(item.placeholder || item.labelName)}
                        value={fieldValue}
                        onChange={handleChange}
                        className="form-control"
                        disabled={isDisabled}
                        required={item.required}
                    />
                );
            
            case 'number-box-with-fetch-button':
                return (
                    <div className="row">
                        <div className="col-7">
                            <Input
                                type="number"
                                id={fieldName} 
                                name={fieldName}
                                placeholder={t(item.placeholder || item.labelName)}
                                value={fieldValue}
                                onChange={handleChange}
                                className="form-control"
                                disabled={isDisabled}
                                required={item.required}
                                min="1" // Good practice for number of questions
                            />
                        </div>
                        <div className="col-5">
                            <Button
                                type="button"
                                color="primary"
                                className="w-100 h-100" 
                                onClick={() => {
                                    // Validate required fields for fetching
                                    if (!values.Topic || !values.Type || !values.Difficulty || !values[fieldName] || parseInt(values[fieldName]) <= 0) { 
                                        toast.warn(t("Please select Topic, Type, Difficulty and enter a valid Number of Questions."));
                                        return;
                                    }
                                    // Ensure SubTopic is included, even if it's empty/null
                                    dispatch(fetchAiQuestions({
                                        Topic: values.Topic, 
                                        SubTopic: values.SubTopic || null, // Send null if not selected
                                        Type: values.Type, 
                                        Difficulty: values.Difficulty, 
                                        Numbercount: values[fieldName] 
                                    }));
                                }}
                                disabled={loadingAi || isDisabled || !values }
                            >
                                {loadingAi ? (
                                    <Spinner size="sm" className="me-2" />
                                ) : (
                                    t(item.buttonLabel || "Fetch Questions")
                                )}
                            </Button>
                        </div>
                    </div>
                );

            case 'topic-dropdown':
                return (
                    <Input
                        type="select"
                        id={fieldName}
                        name={fieldName}
                        value={fieldValue}
                        onChange={handleChange}
                        className="form-control"
                        disabled={isDisabled}
                        required={item.required}
                    >
                        <option value="">{t(item.defaultOptionLabel || "Choose")}</option>
                        {topicsList?.map((topic) => (
                            <option
                                key={topic.ID}
                                value={topic.TopicNameEn} // Assuming value is TopicNameEn based on fetchAiQuestions params
                            >
                                {i18n.language === 'en' ? topic.TopicNameEn : topic.TopicNameAr}
                            </option>
                        ))}
                    </Input>
                );

            case 'sub-topic-dropdown':
                 return (
                    <Input
                        type="select"
                        id={fieldName}
                        name={fieldName}
                        value={fieldValue}
                        onChange={handleChange}
                        className="form-control"
                        disabled={isDisabled || !values.Topic} 
                        required={item.required} 
                    >
                        <option value="">{t(item.defaultOptionLabel || "Choose")}</option>
                        {/* Filter subtopics based on selected topic if topicsList has subtopics nested or fetch subtopics based on topic */}
                        {subTopics?.filter(st => values.Topic ? st.TopicNameEn === values.Topic : true) // Example filter
                          .map((subtopic) => ( 
                            <option
                                key={subtopic.ID}
                                value={subtopic.SubTopicNameEn} // Assuming value is SubTopicNameEn
                            >
                                {i18n.language === 'en' ? subtopic.SubTopicNameEn : subtopic.SubTopicNameAr}
                            </option>
                        ))}
                    </Input>
                );

            case 'check-box':
                return (
                    <div className="form-check mt-2">
                        <Input
                            type="checkbox"
                            id={fieldName}
                            name={fieldName}
                            checked={!!fieldValue}
                            onChange={handleChange}
                            className="form-check-input"
                            disabled={isDisabled}
                            required={item.required}
                        />
                        {item.checkboxLabel && (
                             <label className="form-check-label" htmlFor={fieldName}>
                                {t(item.checkboxLabel)}
                            </label>
                        )}
                    </div>
                );
             case 'type-dropdown': // MODIFIED: Removed inner Col
                return (
                    <select 
                        id={item.name} // Use item.name for id to match label htmlFor
                        name={item.name}
                        value={fieldValue}
                        onChange={handleChange}
                        required={item.required}
                        disabled={isDisabled}
                        className={`form-control`}
                    >
                        <option value="">{t("Choose")}</option>
                        {
                            QuestionTypes?.map((type) => { // Added null check for QuestionTypes
                                return (
                                    <option value={type?.NameEn} key={type?.ID}>{i18n.language === 'en' ? type.NameEn : type.NameAr}</option>
                                )
                            })
                        }
                    </select>
                );

            case 'difficulty-dropdown': // MODIFIED: Removed inner Col
                return (
                    <select 
                        id={item.name} // Use item.name for id to match label htmlFor
                        name={item.name}
                        value={fieldValue}
                        onChange={handleChange}
                        required={item.required}
                        disabled={isDisabled}
                        className={`form-control`}
                    >
                        <option value="">{t("Choose")}</option>
                        {
                            DifficultyLevel?.map((level) => { // Added null check for DifficultyLevel
                                return (
                                    <option value={level?.NameEn} key={level?.ID}>{i18n.language === 'en' ? level.NameEn : level.NameAr}</option>
                                )
                            })
                        }
                    </select>
                );

            case 'question-list':
                if (loadingAi && (!AiQuestions || AiQuestions.length === 0)) { 
                    return (
                        <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '200px' }}>
                            <Spinner style={{ height: "2.5rem", width: "2.5rem" }} className="me-2"> Loading... </Spinner>
                            <span>{t("Fetching Questions...")}</span>
                        </div>
                    );
                }
                return (
                    <CommonDataTable
                        data={questionsForTable} // Use processed questions with IDs
                        tableColumnNames={tableColumnNames} 
                        actionConfig={{ select: true }} 
                        setSelectedIds={(ids) => {
                            setFieldValue('QuestionIDs', ids);; 
                        }}
                    />
                );

            default:
                return <p>Unsupported field type: {item.fieldName}</p>;
        }
    };

    const topInputLabels = labels.filter(item => item.fieldName !== 'question-list');
    const questionListConfig = labels.find(item => item.fieldName === 'question-list');

    return (
        <>
            <Row>
                {topInputLabels.map((item) => {
                    const fieldName = item.name;
                    const colSize = item.fieldName === 'number-box-with-fetch-button' ? 4 :  2;
                    const showLabel = (item.fieldName !== 'check-box' || !item.noMainLabel);


                    return (
                        <Col sm={colSize} key={ item.labelName} className={item.className}>
                            <div className="mb-3">
                                {showLabel && (
                                    <label htmlFor={fieldName} className="col-form-label">
                                        {t(item.labelName)}
                                        {item.required && <span className="text-danger"> *</span>}
                                    </label>
                                )}
                                {renderField(item)}
                                {/* Use destructured touched and errors */}
                                {touched[fieldName] && errors[fieldName] && !skipValidation && (
                                    <div className="text-danger mt-1" style={{ fontSize: "0.875rem" }}>
                                        {typeof errors[fieldName] === 'string' ? t(errors[fieldName]) : errors[fieldName]}
                                    </div>
                                )}
                            </div>
                        </Col>
                    );
                })}
            </Row>

            {questionListConfig && (
                <Row className="mt-3"> 
                    <Col sm={12}> 
                        {renderField(questionListConfig)}
                        {/* Use destructured touched and errors, and check skipValidation */}
                        {touched.QuestionIDs && errors.QuestionIDs && !skipValidation && (
                             <div className="text-danger mt-1" style={{ fontSize: "0.875rem" }}>
                                {typeof formikProps.errors.QuestionIDs === 'string' ? t(formikProps.errors.QuestionIDs) : formikProps.errors.QuestionIDs}
                             </div>
                        )}
                    </Col>
                </Row>
            )}
        </>
    );
};

export default AddAIQuestionForm;